import { render, staticRenderFns } from "./RequestGoodsItems.vue?vue&type=template&id=390c184e&scoped=true&"
import script from "./RequestGoodsItems.vue?vue&type=script&lang=js&"
export * from "./RequestGoodsItems.vue?vue&type=script&lang=js&"
import style0 from "./RequestGoodsItems.vue?vue&type=style&index=0&id=390c184e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390c184e",
  null
  
)

export default component.exports